module.exports = __webpack_public_path__ + "static/media/textediter_video.60d429ab.svg";